import React from 'react';

import FieldEditor from './FormBuilder_FieldEditor';

class SurveyFormBuilder extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.handleAddField = this.handleAddField.bind(this);
    this.handleFieldChange = this.handleFieldChange.bind(this);
  }

  handleAddField() {
    let schema = this.props.schema;

    console.log('will add field');
    console.dir(this.props);

    schema.fields.push({
      type: 'text',

      name: 'field-' + Math.random().toString(36).substring(2)
    });

    if (this.props.onChange) {
      this.props.onChange(schema);
    }
  }

  handleFieldChange(i, data) {
    console.log('filter change!!!');

    let schema = this.props.schema;

    schema.fields[i] = data;

    if (this.props.onChange) {
      this.props.onChange(schema);
    }
  }

  render() {
    if (!this.props.schema) {
      return (
        <div className="alert alert-danger"><i className="fa fa-exclamation-triangle" /> Form schema missing</div>
      );
    }
    return (
      <div>
        {
          this.props.schema.fields.map((field, i) => {
            return (
              <FieldEditor field={field} onChange={(data) => this.handleFieldChange(i, data)} />
            );
          })
        }

        <p><button className="btn btn-sm btn-secondary" onClick={this.handleAddField}><i className="fa fa-plus mr-1" /> Aggiungi domanda</button></p>

      </div>
    );
  }
}

export default SurveyFormBuilder;


// WEBPACK FOOTER //
// ./src/components/marketing/surveys/form_builder/FormBuilder.js